import React, { Component } from "react";
import { connect } from "react-redux";

import { Input } from "@rocketseat/unform";
import PropTypes from "prop-types";

class DataField extends Component {
  static propTypes = {
    onChangeEvent: PropTypes.func,
    numParcela: PropTypes.number,
    acordo: PropTypes.string
  };

  state = {
    value: ""
  };

  componentDidMount() {
    /** Initial value */
    if (this.props.value != null) {
      this.setState({
        value: this.props.value
      });
    }
  }

  componentWillReceiveProps(props) {
    /** Date updated */
    let datas = props.datas.datas;

    if (datas) {
      /** Verifica se o valor dessa parcela foi alterado */
      if (datas[this.props.numParcela]) {
        // Se sim, verifica se é o mesmo valor do atual, caso seja, apenas ignora.
        let value = datas[this.props.numParcela].value;

        if (value != this.state.value) {
          this.setState({
            value: value
          });
        }
      }
    }
  }

  handleChange = event => {
    this.setState({
      value: event.target.value
    });

    /** Executa a função do componente pai (ParcelaForm) */
    this.props.onChangeEvent(
      new Date(event.target.value),
      this.props.numParcela
    );
  };

  render() {
    return (
      <Input
        type="date"
        onChange={this.handleChange}
        className="ant-input"
        name={this.props.name}
        id={this.props.name}
        value={this.state.value}
      />
    );
  }
}
export default connect(state => ({
  datas: state.acordo
}))(DataField);



// WEBPACK FOOTER //
// ./src/components/Acordo/DataField/index.js